import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { CancelButton, FilterButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import SearchBar from "../../../../Components/Utils/SearchBar";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import { TextBase } from "../../../../Components/Text/NormalText";
import { TextMediumBase, TextMediumSM, TextMediumXL, TextMediumXS } from "../../../../Components/Text/MediumText";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Pagination from "../../../../Components/Utils/Pagenation";
import { useFormik } from "formik";
import * as yup from 'yup';
import FormikSelectTwo from "../../../../Components/Utils/Select";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import NuDate from "../../../../Components/Utils/NuDate";
import NuAmount from "../../../../Components/Utils/NuAmount";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";

const ProductComparisonIndex = () => {
  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [filterProps, setFilterProps] = useState({
    category: "",
    subCategory: "",
    underPromotion: "",
    unit: "",
    manufacturer: "",
    brand: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    category: "",
    subCategory: "",
    underPromotion: "",
    unit: "",
    manufacturer: "",
    brand: ""
  });
  const clearFilter = () => {
    setParams({
      ...params, category: "",
      subCategory: "",
      brand: "",
      manufacturer: "",
      underPromotion: "",
      unit: ""
    })
    formik.values.category = ""
    formik.values.subCategory = ""
    formik.values.brand = ""
    formik.values.manufacturer = ""
    formik.values.underPromotion = ""
    formik.values.unit = ""


    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, category: value.category, subCategory: value.subCategory, underPromotion: value?.underPromotion, unit: value?.unit, brand: value?.brand, manufacturer: value?.manufacturer })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        category: "",
        subCategory: "",
        underPromotion: "",
        unit: "",
        manufacturer: "",
        brand: ""
      });
    }
  })
  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  // const clearFilter = ()=> {
  //   setParams({...params,category:"", subCategory:"", underPromotion:"", unit:"", brand:"", manufacturer:""})
  //     setFilter(false)
  // }
  const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/supplier-quotations/price-listing', params);
  const { value: Unit } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Unit_item', showFilterDialog)
  const { value: brand } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'brand_item', showFilterDialog)
  const { value: Manufacture } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Manufacture_item', showFilterDialog)
  const { category: itemsCategory, subCategory: itemsSubCategory, getCategory } = UseCatSubCatDropDown('/category/ItemCategory', "ItemCategory", formik?.values?.category);
  console.log("ddddddd", data);
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount]);

  return (
    <div className='w-full h-full px-2 sm:px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className='w-full md:w-auto flex justify-between items-center gap-2'>
          <Breadcrumb
            items={[
              { name: "Procurement" },
              { name: "Product Comparison" },
            ]} />
          <div className='flex md:hidden items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2'>
          <div className="w-full md:w-fit">
            <SearchBar handleChange={(e) => setParams({ ...params, search: e.target.value })} value={params?.search} />
          </div>
          <div className='hidden md:flex items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>
        </div>
      </div>
      <div className="w-full h-[calc(100vh-200px)] lg:h-[calc(100vh-180px)] bg-white mt-3 mx-auto p-2 rounded-md overflow-x-auto overflow-y-scroll">
        <table className=' w-full min-w-[650px] max-h-[calc(100vh-200px)] overflow-y-auto mt-2 '>
          <thead>
            <tr className='border-b border-[#C4C2C2] text-[#4F4768]'>
              <th className=' w-[30%] text-left text-xs font-semibold py-2 px-4'>Product Name</th>
              <th className=' w-[20%] text-left text-xs font-semibold py-2 px-4'>Supplier1</th>
              <th className=' w-[20%] text-left text-xs font-semibold py-2 px-4'>Supplier2</th>
              <th className=' w-[20%] text-left text-xs font-semibold py-2 px-4'>Supplier3</th>
              <th className=' w-[10%] text-center text-xs font-semibold py-2 px-4'>More..</th>
            </tr>
          </thead>
          <tbody>
            {dataLoading ? (
              <tr>
                <td colSpan={5}>
                  <div className="w-full h-[50vh] flex justify-center items-center">
                    <div className="flex flex-row gap-2">
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.3s]" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.5s]" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.7s]" />
                    </div>
                  </div>
                </td>
              </tr>
            ) : data && data.length > 0 ? (
              data.map((value, index) => {
                const prices = value?.quotes ? value.quotes.map(sup => sup.price) : [];
                const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
                return (
                  <tr key={index} className='hover:text-[#048178] hover:shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px] hover:scale-y-105 text-[#606279] ' >
                    <td className=' w-[30%] py-2 text-left text-xs px-4'>
                      {/* <TextMediumBase content={value?.productName}/> */}
                      <p className="text-xs text-[#606279]"> <Link to={`/procurement/product-comparison/view/${value?.productId}`}>
                        {value?.productName}</Link></p>
                    </td>
                    {value?.quotes == "" || !value?.quotes || value?.quotes.length === 0 ?
                      <>
                        <td className=' w-[20%] py-2 text-xs px-4'>
                          -
                        </td>
                        <td className=' w-[20%] py-2 text-xs px-4'>
                          -
                        </td>
                        <td className=' w-[20%] py-2 text-xs px-4'>
                          -
                        </td>
                      </>
                      :
                      value?.quotes?.slice(0, 3).map((sup, index) => {
                        console.log("TEST", sup);

                        return (
                          <td key={index} className=' w-[20%] py-2 text-xs px-4'>
                            <div className="w-full flex justify-start gap-2 p-1">
                              <div className="">
                                {/* <p className="text-[14px]  ">{sup?.price}<span className="pl-0.5 text-[8px] 2xl:text-[10px] text-gray-400">{`(${sup?.date && NuDate({value:sup?.date,format:"DD-MMM-YYYY"})})`}</span></p> */}
                                <div className={`text-[16px] ${sup?.price === minPrice && sup?.price !== 0 ? 'text-green-600' : ''}`}>
                                  <div>
                                    <NuAmount currency={sup?.currency} value={sup?.price || 0} />
                                    {sup?.isRecent && <span className=" text-red-600">*</span>}
                                    <span className="pl-0.5 text-[8px] 2xl:text-[10px] text-gray-400">
                                      {`(${sup?.date && NuDate({ value: sup?.date, format: "DD-MMM-YY" })})`}
                                    </span>
                                  </div>
                                </div>
                                <p className="text-xs text-gray-500">{sup?.vendorName}</p>
                                {/* <TextMediumSM content={sup?.vendorName} align="center"/> */}
                                {/* <TextMediumXS content={sup?.price} align="center"/>
                      <TextMediumXS content={sup?.date && NuDate({value:sup?.date,format:"DD-MM-YYYY"})} align="center"/> */}
                              </div>
                              <div className="flex justify-center items-center">
                                {sup?.count === 1 ?
                                  null
                                  :
                                  <Link to={`/procurement/product-comparison/priceView/${value?.productId}/${sup?.vendorId}`}>
                                    <div className="w-5 h-5 py-0.5 rounded-full bg-baseColor-primary cursor-pointer">
                                      <TextMediumXS content={sup?.count} align="center" color="text-white" />
                                    </div>
                                  </Link>
                                }
                              </div>
                            </div>
                          </td>
                        )
                      })}
                    {value?.quotes && value?.quotes.length == 1 ?
                      <>
                        <td className=' w-[20%] py-2 text-xs px-4'>
                          -
                        </td>
                        <td className=' w-[20%] py-2 text-xs px-4'>
                          -
                        </td>
                      </>
                      :
                      null
                    }
                    {value?.quotes && value?.quotes.length == 2 ?
                      <td className=' w-[20%] py-2 text-xs px-4'>
                        -
                      </td>
                      :
                      null
                    }
                    <td className=' w-[10%] py-2 text-xs px-[4%]'>
                      <Link to={`/procurement/product-comparison/view/${value?.productId}`}>
                        <ViewIcon color='#048178' />
                      </Link>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={5} className="text-center py-12 text-gray-400 text-xs">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="w-full flex justify-end mt-4">
        <Pagination
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
        />
      </div>
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[520px] md:w-[620px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Product Comparison</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <FormikSelectTwo
                  label="Category"
                  placeholder="Choose"
                  Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  label="Sub Category"
                  placeholder="Choose"
                  Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  label="Brand"
                  placeholder="Choose"
                  Options={brand}
                  formik={formik}
                  name="brand"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  label="Manufacturer"
                  placeholder="Choose"
                  Options={Manufacture}
                  formik={formik}
                  name="manufacturer"
                  width="w-full sm:w-1/2"
                  px="2"
                />
              </div>
              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductComparisonIndex;